const ANALYSIS = {
    LEFT_RIGHT_BAT: 'leftRightBat',
    PITCHING_COURSE: 'pitchingCourse',
    BALL_SPEED: 'ballSpeed',
    PITCH_TYPE : 'pitchType',
    HITTING_DIRECTION : 'hittingDirection',
    HITTING_PROPERTY : 'hittingProperty',
    COUNT : 'count',
    RUNNER : 'runner',
    SCORING_RUNNER : 'scoringRunner',
    POINT_DIFFERENCE : 'pointDifference',
    INNING : 'inning',
    AT_BAT : 'atBat',
    INNING_TOP_BATTER : 'inningTopBatter',
    NUMBER_OF_PITCHER_AT_BAT : 'numberOfPitcherAtBat',
    BATTING_ORDER : 'battingOrder',
    DEFENSIVE_POSITION : 'defensivePosition',
    STARTER_RELIEF : 'starterRelief',
    PITCHING_ORDER: 'pitchingOrder',
    TYPE_PITCHER: 'pitchers',
    TYPE_BATTER: 'batters'
};
const TOTAL_DETAIL = {
    TEAM_CONDITION : 'teamCondition',
    PLAYER_CONDITION : 'playerCondition',
    CATEGORY_SECTION : 'categorySection',
    SELECT_PERIOD : 'selectPeriod',
    TARGET_CONDITION : 'targetCondition',
    COLUMN_GROUP : 'columnGroup',
    TYPE: 'type',
}

const END_POINT = {
    columnGroup: 'columnGroup',
    teamCondition : 'teamCondition',
    playerCondition : 'playerCondition',
    categorySection : 'categorySection',
    selectPeriod : 'selectPeriod',
    targetCondition : 'targetCondition',
    type: 'type',
    leftRightBat: 'leftRightBat',
    pitchingCourse: 'pitchingCourse',
    ballSpeed: 'ballSpeed',
    pitchType : 'pitchType',
    hittingDirection : 'hittingDirection',
    hittingProperty : 'hittingProperty',
    count : 'count',
    runner : 'runner',
    scoringRunner : 'scoringRunner',
    pointDifference : 'pointDifference',
    inning : 'inning',
    atBat : 'atBat',
    inningTopBatter : 'inningTopBatter',
    numberOfPitcherAtBat : 'numberOfPitcherAtBat',
    battingOrder : 'battingOrder',
    defensivePosition : 'defensivePosition',
    starterRelief : 'starterRelief',
    pitchingOrder: 'pitchingOrder',
    pitcher: 'pitchers',
    batter: 'batters'
}
export {ANALYSIS, TOTAL_DETAIL, END_POINT}
